// extracted by mini-css-extract-plugin
export var buttonContainer = "_98-1";
export var fontSizeSelect = "_98-3";
export var formatSelect = "_98-2";
export var formats = "_98-4";
export var hidden = "_98-5";
export var icon = "_98-6";
export var select = "_98-0";